import { render, staticRenderFns } from "./DisableBuiltinSort.vue?vue&type=template&id=2d7a852a"
import script from "./DisableBuiltinSort.vue?vue&type=script&lang=js"
export * from "./DisableBuiltinSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports